var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 8332",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171e2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3206"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "\\u20B9",
    transform: "translate(19.805 21.048)",
    fill: "#ffc165",
    fontSize: 12,
    fontFamily: "Lexend-Regular, Lexend"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 743",
    fill: "none",
    stroke: "#ffc165",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 25.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3215",
    transform: "translate(3.878 3.878)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 188",
    cx: 22.622,
    cy: 22.622,
    r: 22.622,
    fill: "url(#referral_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9325",
    transform: "translate(13.852 14.277)",
    fill: "#ffc968"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22439",
    d: "M17.223 8.738a2.909 2.909 0 0 0-2.894-2.562h-2.028a2.907 2.907 0 0 0-2.876 2.562l-.277 2.36a.592.592 0 0 0 .461.664c.277.055.553.111.848.147l2.157-1.622a1.481 1.481 0 0 1 2.286.7l.35 1.051c.627-.074 1.235-.147 1.825-.277a.608.608 0 0 0 .461-.664Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 841",
    cx: 2.728,
    cy: 2.728,
    r: 2.728,
    transform: "translate(10.605)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22440",
    d: "M5.203 10.729H3.175a2.925 2.925 0 0 0-2.894 2.562l-.277 2.36a.608.608 0 0 0 .461.664 17.345 17.345 0 0 0 3.724.387 17.47 17.47 0 0 0 3.724-.387.608.608 0 0 0 .461-.664l-.277-2.36a2.909 2.909 0 0 0-2.894-2.562Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 842",
    cx: 2.728,
    cy: 2.728,
    r: 2.728,
    transform: "translate(1.461 4.554)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22441",
    d: "M13.831 11.356a.371.371 0 0 0-.571-.184l-2.47 1.862a.38.38 0 0 0 .111.664l.7.221a5.114 5.114 0 0 1-2.028 2.6.168.168 0 0 0 .055.295 3.614 3.614 0 0 0 4.019-2.286l.719.221a.368.368 0 0 0 .461-.479Z"
  })))));
};
export default SvgReferral;